<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.15 12.563H5C4.71667 12.563 4.47917 12.4672 4.2875 12.2755C4.09583 12.0838 4 11.8463 4 11.563C4 11.2797 4.09583 11.0422 4.2875 10.8505C4.47917 10.6588 4.71667 10.563 5 10.563H16.15L13.3 7.713C13.1 7.513 13.0042 7.27967 13.0125 7.013C13.0208 6.74633 13.1167 6.513 13.3 6.313C13.5 6.113 13.7375 6.00883 14.0125 6.0005C14.2875 5.99217 14.525 6.088 14.725 6.288L19.3 10.863C19.4 10.963 19.4708 11.0713 19.5125 11.188C19.5542 11.3047 19.575 11.4297 19.575 11.563C19.575 11.6963 19.5542 11.8213 19.5125 11.938C19.4708 12.0547 19.4 12.163 19.3 12.263L14.725 16.838C14.525 17.038 14.2875 17.1338 14.0125 17.1255C13.7375 17.1172 13.5 17.013 13.3 16.813C13.1167 16.613 13.0208 16.3797 13.0125 16.113C13.0042 15.8463 13.1 15.613 13.3 15.413L16.15 12.563Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#E10E1C",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
